(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fuxin-contact-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const model = params.get('model');
    const field = document.querySelector('[data-model-field]');
    if (model && field) field.value = model;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fuxin-news-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const filters = document.querySelector('.fx-news__categories');
    if (!filters) return;
    const cards = [...document.querySelectorAll('[data-news-card]')];
    filters.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-news-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
      const filter = button.dataset.newsFilter;
      cards.forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.newsCategory !== filter;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stamp-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const path = window.location.pathname;
    let key = 'home';
    if (path.startsWith('/collections')) key = 'products';
    if (path.startsWith('/blogs')) key = 'news';
    if (path === '/pages/applications') key = 'applications';
    if (path === '/pages/technical-guide') key = 'guide';
    if (path === '/pages/about-us') key = 'about';
    if (path === '/pages/contact') key = 'contact';
    document.querySelectorAll(`.fx-nav [data-nav="${key}"]`).forEach((link) => link.setAttribute('aria-current', 'page'));
  })();

  } catch(e) { console.error(e); }
})();
})();
